<generic-incident-modal [parent]="this" [busy]="busy">
    <form [formGroup]="form">
        <h2>Driver License Information</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label class="required">Driver License Number</label>
                    <input type="text" class="mvd_form-control" formControlName="driverLicenseNumber" />
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label class="required" title="* Required">Driver License Jurisdiction</label>
                    <select class="mvd_form-control" formControlName="driverLicenseJurisdictionId">
                        <option [value]="null"></option>
                        <option *ngFor="let t of vehicleJurisdictions" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
            </div>
        </fieldset>
        <h2>Registration Information</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label>Vehicle Plate Number</label>
                    <input type="text" class="mvd_form-control" formControlName="vehicleLicensePlateNumber" />
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Vehicle Plate Type</label>
                    <select class="mvd_form-control" formControlName="plateTypeId">
                        <option [value]="null"></option>
                        <option *ngFor="let t of plateTypes" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label>Vehicle Plate Jurisdiction</label>
                    <select class="mvd_form-control" formControlName="vehicleRegistrationJurisdictionId">
                        <option [value]="null"></option>
                        <option *ngFor="let t of vehicleJurisdictions" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Vehicle Make</label>
                    <input type="text" class="mvd_form-control" formControlName="vehicleMake" />
                </div>
            </div>
        </fieldset>
        <h2>Court Information</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label class="required" title="* Required">Court Type</label>
                    <select class="mvd_form-control" formControlName="courtTypeId">
                        <option [value]="null"></option>
                        <option *ngFor="let t of courtTypes" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Court Name</label>
                    <input type="text" class="mvd_form-control" formControlName="courtName" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label>Court Street Address</label>
                    <input type="text" class="mvd_form-control" formControlName="courtStreetAddress" />
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Court City</label>
                    <input type="text" class="mvd_form-control" formControlName="courtCity" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label class="required" title="* Required">Court State</label>
                    <select class="mvd_form-control" formControlName="courtJurisdictionId">
                        <option [value]="null"></option>
                        <option *ngFor="let t of oojJurisdictions" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Court Zip Code</label>
                    <input type="text" class="mvd_form-control" formControlName="courtZipCode" />
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Court Telephone Number</label>
                    <input type="text" class="mvd_form-control" formControlName="courtTelephoneNumber" />
                </div>
            </div>
        </fieldset>
        <h2>Charge Information</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label class="required" title="* Required">Jurisdiction</label>
                    <select class="mvd_form-control" formControlName="reportingJurisdictionId">
                        <option [value]="null"></option>
                        <option *ngFor="let t of oojJurisdictions" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label class="required">Conviction Date</label>
                    <max-calendar [showIcon]="true" formControlName="dispositionDate"></max-calendar>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label class="required">State Native Code</label>
                    <input type="text" class="mvd_form-control" formControlName="stateNativeCode" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label>Approximate Speed</label>
                    <input type="number" class="mvd_form-control" formControlName="approximateSpeed" />
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Lawful Speed</label>
                    <input type="number" class="mvd_form-control" formControlName="lawfulSpeed" />
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label [ngClass]="{ 'required': bacRequired }" [attr.title]="bacRequired ? '* Required' : null">
                        BAC
                    </label>
                    <input type="number" class="mvd_form-control" formControlName="bac" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label class="required" title="* Required">Accident Indicator</label>
                    <select class="mvd_form-control" formControlName="accidentTypeId">
                        <option [value]="null"></option>
                        <option *ngFor="let t of accidentTypes" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label [ngClass]="{ 'required': underlyingAcdCodeRequired }" [attr.title]="underlyingAcdCodeRequired ? '* Required' : null">
                        Underlying Acd Code
                    </label>
                    <select class="mvd_form-control" formControlName="underlyingAcdCodeId" [attr.disabled]="(true == (false == underlyingAcdCodeRequired ? true : false) && !isExistingIncident) ? true: null">
                        <option [value]="null"></option>
                        <option *ngFor="let t of acdCodes" [value]="t.value">{{ t.text }}</option>
                    </select>
                    <div class="mvd_alert__rule" *ngIf="form.hasError('nullUnderlyingAcdCodeId')">Must fill out if Occurrence Date 09/30/2005 or later</div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label>Complaint Number</label>
                    <input type="text" class="mvd_form-control" formControlName="complaintNumber" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>CDL Holder</label>
                    <input type="checkbox" class="mvd_form-control" formControlName="isCDLHolder" />
                </div>
                <div class="col-sm-12 mvd_form-group">
                    <label>Violation Occurred in Commercial Vehicle</label>
                    <input type="checkbox" class="mvd_form-control" formControlName="commercialMotorVehicleIndicator" />
                </div>
                <div class="col-sm-12 mvd_form-group">
                    <label>Violation Occurred While Transporting Hazardous Materials</label>
                    <input type="checkbox" class="mvd_form-control" formControlName="hazardousMaterialIndicator" />
                </div>
                <div class="col-sm-12 mvd_form-group">
                    <label>Violation Occurred While Transporting 16 or More Passengers</label>
                    <input type="checkbox" class="mvd_form-control" formControlName="passengerIndicator" />
                </div>
            </div>
        </fieldset>
    </form>
</generic-incident-modal>